export default (data: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve((reader.result ?? "").toString());
    reader.onerror = (err) => reject(err);
  });
};
